// Re-export the default API client for backward compatibility
import apiClient from './api/client';

// Default export for: import api from '@/lib/api'
export default apiClient;

// Named export for: import { api } from '@/lib/api'
export const api = apiClient;

// Re-export everything else from client
export * from './api/client';